<figure 
    class="sponsor-container" 
    id="sponsor-scroll" 
    [style.aspectRatio]="handleRatio()" 
    [style.backgroundImage]="handleBackgroundImage()" 
    [style.display]="display ? 'block' : 'none'"
    (click)="openAdLink()"
></figure>
